import { useEffect } from 'react'
import TagManager from 'react-gtm-module'

import { useBoundStore } from '../store/store'
import type { ApiResponse } from '../types/api'
import { api } from '../utils/api-client'

interface DepositEvent {
  account: string
  amount: string
  bank_account: string
  bank_account_name: string
  billno: string
  cardID: string
  checkPerson: string
  depStatus: string
  endTime: string
  fee: string
  for_bankverify: string
  id: string
  payType: string
  platInfo: string
  requestTime: string
  saveName: string
  saveTime: string
  userType: string
  is_first_deposit: number
}

const useDepositEvents = () => {
  const username = useBoundStore(state => state.user.username)
  const email = useBoundStore(state => state.user.email)
  const phone = useBoundStore(state => state.user.phone)

  useEffect(() => {
    if (!username) return
    const getDepositEvents = async () => {
      try {
        const res = await api.post<ApiResponse<DepositEvent[]>>(
          '/conduct.php',
          {
            type: 'get_new_successful_deposits',
          },
        )
        const { status, info } = res.data
        if (status === 1 && info.length >= 1) {
          info.forEach(depositEvent => {
            if (+depositEvent.is_first_deposit) {
              TagManager.dataLayer({
                dataLayer: {
                  event: 'first_time_deposit',
                  email,
                  transaction_id: depositEvent.billno,
                  value: depositEvent.amount,
                  currency: 'MXN',
                  items: [
                    {
                      item_id: depositEvent.platInfo,
                      item_name: depositEvent.platInfo,
                      price: depositEvent.amount,
                      quantity: '1',
                      currency: 'MXN',
                    },
                  ],
                },
              })
            }

            TagManager.dataLayer({
              dataLayer: {
                event: 'purchase',
                transaction_id: depositEvent.billno,
                value: depositEvent.amount,
                currency: 'MXN',
                items: [
                  {
                    item_id: depositEvent.platInfo,
                    item_name: depositEvent.platInfo,
                    price: depositEvent.amount,
                    quantity: '1',
                    currency: 'MXN',
                  },
                ],
              },
            })

            // FB
            fbq('track', 'Purchase', {
              value: Number(depositEvent.amount),
              currency: 'MXN',
            })          
            // Twitter
            twq('event', 'tw-olsug-oltwu', {
              value: depositEvent.amount,
              currency: 'MXN',
              contents: [depositEvent],
              email_address: email,
              phone_number: `+52${phone}`,
            })
          })

          await api.post('/conduct.php', {
            type: 'clear_new_successful_deposits',
          })
        }
      } catch (error) {
        console.error(error)
      }
    }

    getDepositEvents()
  }, [username])
}

export default useDepositEvents
